import 'phaser'
import { createId } from '../main/common'
import { layers } from '../main/layers-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ICargoType, ICargoData } from './cargoesData'

import { IEntity } from './entitiesUtils'
import { entitiesUtils } from './entitiesUtils-sidecar'
import { l } from '../lib/imports'
import { distance } from '../lib/distance-sidecar'
import { IMonster } from '../monsters/monsters'
import { cargoesData } from './cargoesData-sidecar'
import { IMachine } from '../machines/machines'

export interface ICargo extends IEntity {
  data: ICargoData
  image: Phaser.GameObjects.Image
  i: number
  j: number
  carriedBy: IMonster | null
  inStack: IMachine | null
  isInShip: boolean
  xStagger: number
  yStagger: number
}

const objs: ICargo[] = []
export function getAll() {
  return objs
}
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}
export function findClosestTo(
  i: number,
  j: number,
  filter: (c: ICargo) => boolean,
  invalid: ICargo[] = [],
) {
  return distance.findClosestTo(objs, i, j, filter, invalid)
}
export function exist(filter: (f: ICargo) => boolean, invalid: ICargo[] = []) {
  return distance.exists(objs, filter, invalid)
}
export function existsOfType(type: ICargoType, invalid: ICargo[] = []) {
  return distance.exists(objs, (f) => f.data.type === type, invalid)
}

export function findAtSpot(
  i: number,
  j: number,
  filter: (c: ICargo) => boolean,
  allowFromStack: boolean,
): ICargo | null {
  let closest: ICargo | null = null
  l.forEach(objs, (c) => {
    if (c.i === i && c.j === j) {
      if (filter(c)) {
        if (allowFromStack || c.inStack === null) {
          closest = c
          return false
        }
      }
    }
  })
  return closest
}

export function create(type: ICargoType): ICargo {
  let id = createId()
  let data = cargoesData.dataMapName[type]

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().cargo,
    data.frame,
    0,
    0,
  )

  let obj: ICargo = {
    data,
    eType: 'cargo',
    id,
    image,
    isDead: false,
    i: -1,
    j: -1,
    carriedBy: null,
    inStack: null,
    isInShip: true,
    xStagger: 0,
    yStagger: 0,
  }
  shuffleStagger(obj)
  objs.push(obj)

  console.log('created cargo!')
  // moveToTile(obj, )

  return obj
}

export function shuffleStagger(obj: ICargo) {
  obj.xStagger = l.random(-4, 4, false)
  obj.yStagger = l.random(-4, 0, false)
}

export function moveToTile(
  obj: ICargo,
  map: ITileMapShip,
  x: number,
  y: number,
) {
  obj.image.x = map.ox + x * map.tileSize + obj.xStagger * 2
  obj.image.y = map.oy + y * map.tileSize + obj.yStagger * 2
  obj.i = x
  obj.j = y
  shuffleStagger(obj)
}

export function killAll() {
  objs.forEach((c) => {
    kill(c)
  })
}
export function kill(obj: ICargo) {
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: ICargo) {
  if (obj.isInShip || obj.carriedBy) {
    obj.image.rotation = 0
  } else {
    obj.image.rotation += 0.01
  }
}
